import { useEffect, useState } from "react";
import { ContextType, FilterMetadataApiWithCountReturn, ROUTE, WaterProvider } from "../misc";
import { useProvidersMetadataWithCount } from "../ProviderFilter";
import { fetchProviderById } from "../misc";
import { useHistory } from "react-router-dom";

export const useMetadataAndProviderLoader = (adminId?: string) => {
    const history = useHistory();
    const [metadata, setMetadata] = useState<FilterMetadataApiWithCountReturn>(undefined);
    const [metadataLoading, setMetadataLoading] = useState(undefined);
    const [loading, setLoading] = useState(undefined);
    const [provider, setProvider] = useState<WaterProvider>(undefined);

    useProvidersMetadataWithCount({
        setMetadataWithCount: setMetadata,
        metadataWithCount: metadata,
        setMetadataLoading
    });

    useEffect(() => {
        const load = async adminId => {
            if (adminId == null || adminId.toString().trim() === "") return;

            setLoading(true);
            const provider = await fetchProviderById(adminId);
            setProvider(provider);
            setLoading(false);
        };
        load(adminId);
    }, [adminId]);

    useEffect(() => {
        const init = loading === undefined || metadataLoading === undefined;
        const _loading = loading || metadataLoading;
        if (!init && !_loading && (!metadata || !provider)) {
            history.push(`${ROUTE.SEARCH_PAGE}`);
        }
    }, [metadata, provider, loading, metadataLoading, history]);

    return { metadata, provider, loading, metadataLoading };
};
export const useProviderInfoPage = (adminId: string) => {
    const { metadata, provider, loading } = useMetadataAndProviderLoader(adminId);
    const contextType: ContextType = "info";
    return { metadata, provider, loading, contextType };
};
